export default "__VITE_ASSET__4795be54__"